import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomerAccountDetailsComponent } from '@app/customer-account/customer-account-details/customer-account-details.component';
import { CustomerAccountVisitComponent } from '@app/customer-account/customer-account-visits/customer-account-visit/customer-account-visit.component';
import { CustomerAccountVisitsComponent } from '@app/customer-account/customer-account-visits/customer-account-visits.component';
import { CustomerAccountComponent } from '@app/customer-account/customer-account/customer-account.component';
import { NavigationComponent } from '@app/customer-account/navigation/navigation.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  declarations: [
    CustomerAccountComponent,
    CustomerAccountDetailsComponent,
    CustomerAccountVisitsComponent,
    NavigationComponent,
    CustomerAccountVisitComponent
  ],
  exports: [
    CustomerAccountVisitComponent
  ]
})
export class CustomerAccountModule { }
